//websockets
import Rewebsocket from 'reconnecting-websocket'

function guid() {
	return 'xxxxxxxx-xxxx-7xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		let r = (Math.random() * 16) | 0,
			v = c == 'x' ? r : (r & 0x3) | 0x8
		return v.toString(16)
	})
}

function initWS() {
	let url = 'ws://127.0.0.1:10951/cv'
	// let url = 'ws://192.168.22.170:10951/cv'
	return new Rewebsocket(url, null, {
		automaticOpen: true, // 实例化后立即连接 ws.open()和 ws.close() 可以手动管理
		reconnectInterval: 1000, // 重新连接延迟时间
		maxReconnectInterval: 3000, // 等待重连最长时间
		reconnectDecay: 1, // 延迟重连时间的增加率
		timeoutInterval: 3000, // 在关闭和重试之前等待连接成功的最长时间
		maxReconnectAttempts: 15 // 最大尝试重连次数
	})
}

async function openWs(ws, callback) {
	ws.onopen = function(data) {
		callback(data)
	}
}

function sendWS(ws, key, data) {
	const params = {
		key: guid(),
		from: guid(),
		owner: key,
		req: data
	}
	ws.send(JSON.stringify(params))
}

function messageWS(ws, callback) {
	ws.onmessage = function(resp) {
		callback(JSON.parse(resp.data))
	}
}

function errorWS(ws, callback) {
	ws.onerror = function(data) {
		callback(data)
	}
}

class handleWs {
	constructor(url = 'ws://127.0.0.1:8000/cv') {
		this.url = url
		this.ws = this.initWS()
	}
	guid() {
		return 'xxxxxxxx-xxxx-7xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			let r = (Math.random() * 16) | 0,
				v = c == 'x' ? r : (r & 0x3) | 0x8
			return v.toString(16)
		})
	}
	initWS() {
		return new Rewebsocket(this.url, null, {
			automaticOpen: true, // 实例化后立即连接 ws.open()和 ws.close() 可以手动管理
			reconnectInterval: 1000, // 重新连接延迟时间
			maxReconnectInterval: 3000, // 等待重连最长时间
			reconnectDecay: 1, // 延迟重连时间的增加率
			timeoutInterval: 3000, // 在关闭和重试之前等待连接成功的最长时间
			maxReconnectAttempts: 15 // 最大尝试重连次数
		})
	}
	openWs() {
		this.ws.onopen = data => {
			return data
		}
	}
	sendWS(key, data) {
		const params = {
			key: this.guid(),
			from: this.guid(),
			owner: key,
			req: data
		}
		this.ws.send(JSON.stringify(params))
	}
	messageWS() {
		this.ws.onmessage = resp => {
			return JSON.parse(resp.data)
		}
	}
	errorWS() {
		this.ws.onerror = data => {
			return data
		}
	}
}

export { initWS, openWs, errorWS, sendWS, messageWS, handleWs }
